import { defineStore } from 'pinia'
import {
  modelCollectionState,
  modelCollectionActions,
  modelCollectionGetters,
} from '@app/stores/ModelCollectionStore.ts'
import { useSurveyResponseStore } from '@app/stores/SurveyResponseStore.ts'

export const useRecipientStore = defineStore('RecipientStore', {
  state: () => {
    return { ...modelCollectionState('recipients') }
  },
  getters: { ...modelCollectionGetters('recipients') },
  actions: {
    ...modelCollectionActions('recipients'),
    upsertRecipientAndResponses(recipient) {
      this.upsertRecipient(recipient)
      useSurveyResponseStore().upsertSurveyResponses(recipient.responses)
    },
  },
})
